import React from "react";
import converter from './markdownConverter'
import DOMPurify from "dompurify";
import parse from 'html-react-parser';
import hljs from 'highlight.js';


export function SharedRichText(props: { content: string }) {

    const html = converter.makeHtml(props.content);

    return <div className="row">
        <div className="col-sm-12">
            {html ? parse(html) : ''}
        </div>

    </div>
}